// ═══ 데스크톱(≥1024) 신청 1페이지 — 좌측 폼 (신고 371 §8 C1) ═══
// 시안 정본 docs/design/bug371-buyer-web/desktop/c1/index.html 의 C 신청 `.rgrid .lcol`.
// 상태 머신(mode/step/ocr)은 SimpleNewRequest.js, 검증·FormData·중복 선검사는 request/useRequestSubmit.js 에 있고,
// 이 파일은 같은 상태를 3단계 세로 흐름 대신 한 화면에 펼쳐 보여주기만 한다(로직 복제 0).
import React from 'react';
import { T, R, FONT } from '../../../theme';
import SimpleCard from '../../parts/SimpleCard';
import StepMethod from './StepMethod';
import { FUELS } from './StepVehicle';
import { Field, NoteBox, AmberBox, input, select, textarea, errSt, linkBtn, btnNavy, btnPlain, btnDisabled } from './bits';

var col = { display: 'flex', flexDirection: 'column', gap: 12, minWidth: 0 };
var headRow = { display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' };
var backBtn = { border: 0, background: 'none', padding: 0, cursor: 'pointer', color: T.muted, fontSize: 18, lineHeight: 1, fontFamily: 'inherit' };
var titleSt = { fontSize: 20, fontWeight: 800, letterSpacing: '-.4px', color: T.navy };
var prog = { display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 0, maxWidth: 420 };
var progTrack = { flex: 1, height: 4, borderRadius: R.pill, background: T.track, overflow: 'clip' };
var progFill = { display: 'block', height: '100%', background: T.accent, borderRadius: R.pill };
var progLab = { display: 'flex', alignItems: 'center', gap: 8, fontSize: FONT.label, fontWeight: 700, color: T.muted, flex: 'none' };
var progOn = { color: T.accentPress };

var body = { padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 11 };
var fgrid = { display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0,1fr))', gap: '10px 12px', padding: '12px 14px' };
var w2 = { gridColumn: 'span 2', minWidth: 0 };
var w4 = { gridColumn: 'span 4', minWidth: 0 };
var one = { minWidth: 0 };

var dropWrap = { display: 'flex', alignItems: 'center', gap: 12, padding: 14, border: '1.5px dashed ' + T.accentBd,
  borderRadius: R.card, background: T.accentTint };
var dropBtn = { display: 'flex', alignItems: 'center', gap: 14, flex: 1, minWidth: 0, border: 0, background: 'none',
  padding: 0, textAlign: 'start', cursor: 'pointer', fontFamily: 'inherit' };
var dropIcon = { width: 40, height: 40, borderRadius: R.md, background: T.card, border: '1px solid ' + T.accentBd,
  display: 'grid', placeItems: 'center', color: T.accentPress, flex: 'none' };
var dropTitle = { display: 'block', fontSize: 13, fontWeight: 800, color: T.accentPress };
var dropSub = { display: 'block', fontSize: 11.5, color: T.dim, lineHeight: 1.5, marginTop: 1 };
var thumbs = { display: 'flex', gap: 8, flex: 'none', direction: 'ltr' };
var thumb = { position: 'relative', width: 62, height: 48, borderRadius: R.md, overflow: 'clip',
  border: '1px solid ' + T.bd, background: T.head, flex: 'none' };
var thumbImg = { width: '100%', height: '100%', objectFit: 'cover', display: 'block' };
var thumbName = { width: '100%', height: '100%', display: 'grid', placeItems: 'center', fontSize: 9, color: T.faint,
  padding: 2, textAlign: 'center', wordBreak: 'break-all' };
var del = { position: 'absolute', insetInlineEnd: 2, top: 2, width: 17, height: 17, borderRadius: R.pill,
  border: 0, background: T.ink, color: T.card, fontSize: 10, lineHeight: 1, cursor: 'pointer', fontFamily: 'inherit', padding: 0 };

var choiceGrid = { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gap: 10 };
var ch = { display: 'flex', flexDirection: 'column', gap: 5, padding: 12, borderRadius: R.card,
  border: '1px solid ' + T.bd, background: T.card, cursor: 'pointer', fontFamily: 'inherit', textAlign: 'start', width: '100%' };
var chOn = { border: '1px solid ' + T.accent, background: T.accentTint };
var chRow = { display: 'flex', alignItems: 'center', gap: 7 };
var rd = { width: 15, height: 15, borderRadius: R.pill, flex: 'none', border: '1.5px solid ' + T.line, boxSizing: 'border-box' };
var rdOn = { border: '4.5px solid ' + T.accent };
var chT = { fontSize: 12.5, fontWeight: 800, color: T.ink };
var chTOn = { color: T.accentPress };
var chP = { fontSize: 11.5, color: T.muted, lineHeight: 1.55 };
var ocrLine = { display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px', borderRadius: R.md,
  background: T.accentTint, border: '1px solid ' + T.accentBd, color: T.accentPress, fontSize: 12, fontWeight: 700 };
var runRow = { display: 'flex', justifyContent: 'flex-start' };
var picks = { display: 'flex', gap: 7, alignItems: 'flex-end', minWidth: 0 };
var pickBtn = Object.assign({}, btnPlain, { height: 34, flex: 1, fontSize: 12.5, padding: '0 10px' });
var pill = { display: 'inline-flex', alignItems: 'center', maxWidth: '100%', height: 28, padding: '0 11px',
  borderRadius: R.pill, border: '1px solid ' + T.accentBd, background: T.accentTint, color: T.accentPress,
  fontSize: 11.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', overflow: 'hidden',
  textOverflow: 'ellipsis', whiteSpace: 'nowrap' };

function UploadGlyph() {
  var st = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.7, strokeLinecap: 'round', strokeLinejoin: 'round' };
  return (<svg width="19" height="19" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M12 16V4.8M8.2 8.6L12 4.8l3.8 3.8M4.6 15.2v2.6a2 2 0 002 2h10.8a2 2 0 002-2v-2.6" {...st} />
  </svg>);
}

function Choice(props) {
  return (<button type="button" data-choice={props.id} aria-pressed={props.on}
    style={props.on ? Object.assign({}, ch, chOn) : ch} onClick={props.onClick}>
    <span style={chRow}>
      <span style={props.on ? Object.assign({}, rd, rdOn) : rd} />
      <b style={props.on ? Object.assign({}, chT, chTOn) : chT}>{props.title}</b>
    </span>
    <span style={chP}>{props.desc1}</span>
    <span style={chP}>{props.desc2}</span>
  </button>);
}

/// 제목 옆 얇은 진행 표시 — 3단계 세로 스텝퍼(RequestStepper) 의 데스크톱 축약형(시안 `.prog`).
function Progress(props) {
  var t = props.t;
  var keys = ['simpleStepMethod', 'simpleStepVehicle', 'simpleStepLocation'];
  return (<span style={prog} data-testid="req-progress" data-done={props.done}>
    <span style={progTrack}><i style={Object.assign({}, progFill, { width: (props.done / 3 * 100) + '%' })} /></span>
    <span style={progLab}>
      {keys.map(function (k, i) {
        return (<React.Fragment key={k}>
          {i > 0 ? <b style={{ color: T.faint }}>·</b> : null}
          <span style={i < props.done ? progOn : null}>{t(k)}</span>
        </React.Fragment>);
      })}
    </span>
  </span>);
}

function PhotoCard(props) {
  var t = props.t;
  var photos = props.photos;
  var full = photos.length >= 3;
  return (<SimpleCard title={t('simpleB4PhotoTitle')}
    right={photos.length ? <span style={{ fontSize: 11.5, color: T.faint }}>{t('inspPhotoCount', { count: photos.length })}</span> : null}>
    <div style={body}>
      <div style={dropWrap} data-testid="desk-drop"
        onDragOver={function (e) { e.preventDefault(); }}
        onDrop={function (e) { e.preventDefault(); props.onDropFiles(e.dataTransfer && e.dataTransfer.files); }}>
        <button type="button" style={full ? Object.assign({}, dropBtn, btnDisabled) : dropBtn}
          data-testid="desk-drop-pick" disabled={full} onClick={props.onAdd}>
          <span style={dropIcon}><UploadGlyph /></span>
          <span style={{ minWidth: 0 }}>
            <b style={dropTitle}>{t('simpleB4Add')}</b>
            <span style={dropSub}>{t('simpleTipSub')}</span>
          </span>
        </button>
        {photos.length ? (<span style={thumbs}>
          {photos.map(function (p, i) {
            return (<span key={p.key} style={thumb} data-testid="desk-thumb">
              {p.url ? <img src={p.url} alt="" style={thumbImg} /> : <span style={thumbName}>{p.name}</span>}
              <button type="button" style={del} aria-label={t('evalActionDelete')} data-remove={i}
                onClick={function () { props.onRemove(i); }}>✕</button>
            </span>);
          })}
        </span>) : null}
      </div>
      {props.error ? <div style={errSt} role="alert">{props.error}</div> : null}

      {props.ocr === 'failed' ? (<AmberBox role="alert" title={t('simpleB4OcrFailedTitle')} sub={t('simpleB4OcrFailedSub')}>
        <button type="button" style={linkBtn} onClick={props.onManualEntry}>{t('simpleB4ManualEntry')}</button>
        <button type="button" style={Object.assign({}, linkBtn, { color: T.muted })} onClick={props.onRetry}>{t('simpleOcrRetry')}</button>
      </AmberBox>) : null}

      <div style={choiceGrid}>
        <Choice id="ai" on={props.choice === 'ai'} title={t('simpleB4ChoiceAiTitle')}
          desc1={photos.length === 1 ? t('simpleB4ChoiceAiDesc1Single') : t('simpleB4ChoiceAiDesc1')}
          desc2={t('simpleB4ChoiceAiDesc2')} onClick={function () { props.onChoice('ai'); }} />
        <Choice id="direct" on={props.choice === 'direct'} title={t('simpleB4ChoiceDirectTitle')}
          desc1={t('simpleB4ChoiceDirectDesc1')} desc2={t('simpleB4ChoiceDirectDesc2')}
          onClick={function () { props.onChoice('direct'); }} />
      </div>

      {props.ocr === 'loading' ? <div style={ocrLine} role="status">{t('simpleB4OcrLoading')}</div> : null}
      {props.choice === 'ai' && props.ocr !== 'loading' && props.ocr !== 'filled' ? (<div style={runRow}>
        <button type="button" data-testid="desk-ocr" style={Object.assign({}, btnNavy, { height: 36 })}
          onClick={props.onRunOcr}>{t('simpleB4ChoiceSubmit')}</button>
      </div>) : null}
    </div>
  </SimpleCard>);
}

function VehicleCard(props) {
  var t = props.t;
  var f = props.form;
  var set = props.onChange;
  return (<SimpleCard title={t('simpleStepVehicle')}
    right={props.ocrFilled ? <span style={{ fontSize: 11.5, color: T.accentPress, fontWeight: 700 }}>{t('simpleOcrFilled')}</span> : null}>
    {props.ocrFilled ? (<div style={{ padding: '12px 14px 0' }}>
      <AmberBox title={t('simpleOcrFilled')} sub={props.photoCount ? t('inspPhotoCount', { count: props.photoCount }) : ''} />
    </div>) : null}
    <div style={fgrid}>
      <div style={w2}>
        <Field label={t('evalFormModel')} required htmlFor="req-model" error={props.modelError}>
          <input id="req-model" style={input} value={f.car_model} placeholder={t('evalFormModelHint')}
            onChange={function (e) { set('car_model', e.target.value); }} />
        </Field>
      </div>
      <div style={w2}>
        <Field label={t('evalFormDetail')} htmlFor="req-detail">
          <input id="req-detail" style={input} value={f.car_detail} onChange={function (e) { set('car_detail', e.target.value); }} />
        </Field>
      </div>
      <div style={one}>
        <Field label={t('evalFormCarNumber')} htmlFor="req-plate">
          <input id="req-plate" dir="ltr" style={input} value={f.car_number} onChange={function (e) { set('car_number', e.target.value); }} />
        </Field>
      </div>
      <div style={one}>
        <Field label={t('evalFormYear')} htmlFor="req-year">
          <input id="req-year" dir="ltr" inputMode="numeric" style={input} value={f.car_year} onChange={function (e) { set('car_year', e.target.value); }} />
        </Field>
      </div>
      <div style={one}>
        <Field label={t('evalFormMileage')} htmlFor="req-mileage">
          <input id="req-mileage" dir="ltr" inputMode="numeric" style={input} value={f.car_mileage} onChange={function (e) { set('car_mileage', e.target.value); }} />
        </Field>
      </div>
      <div style={one}>
        <Field label={t('evalFormFuel')} htmlFor="req-fuel">
          <select id="req-fuel" style={select} value={f.car_fuel} onChange={function (e) { set('car_fuel', e.target.value); }}>
            {FUELS.map(function (o) {
              return <option key={o.value} value={o.value}>{o.labelKey ? t(o.labelKey) : o.value}</option>;
            })}
          </select>
        </Field>
      </div>
      <div style={w2}>
        <Field label={t('evalFormSellerPhone')} htmlFor="req-phone">
          <input id="req-phone" dir="ltr" inputMode="tel" style={input} value={f.seller_phone}
            onChange={function (e) { set('seller_phone', e.target.value); }} />
        </Field>
      </div>
    </div>
  </SimpleCard>);
}

function LocationCard(props) {
  var t = props.t;
  var f = props.form;
  var set = props.onChange;
  return (<SimpleCard title={t('simpleStepLocation')}>
    <div style={fgrid}>
      {props.open ? (<React.Fragment>
        <div style={w2}>
          <Field label={t('evalFormLocation')} htmlFor="req-location" error={props.locationError}>
            <input id="req-location" style={input} value={f.location} placeholder={t('evalFormLocationHint')}
              onChange={function (e) { set('location', e.target.value); }} />
          </Field>
        </div>
        <div style={one}>
          <Field label={t('evalFormLocationDetail')} htmlFor="req-locdetail">
            <input id="req-locdetail" style={input} value={f.location_detail} placeholder={t('simpleLocDetailHint')}
              onChange={function (e) { set('location_detail', e.target.value); }} />
          </Field>
        </div>
        <div style={Object.assign({}, one, picks)}>
          <button type="button" style={pickBtn} data-testid="pick-map" onClick={props.onPickMap}>{t('simplePickMap')}</button>
          <button type="button" style={pickBtn} data-testid="pick-addr" onClick={props.onPickAddr}>{t('simplePickAddr')}</button>
        </div>
        {props.showRefLink ? (<div style={w2}>
          <Field label={t('simpleB3RefLink')} htmlFor="req-reflink" error={props.urlError}>
            <input id="req-reflink" type="url" dir="ltr" style={input} value={f.listing_url} placeholder="https://"
              onChange={function (e) { set('listing_url', e.target.value); }} />
          </Field>
        </div>) : null}
      </React.Fragment>) : (<div style={w4}><NoteBox><div>{t('simpleB4PhotoNote')}</div></NoteBox></div>)}
      <div style={w4}>
        <Field label={t('simpleMemoLabel')} htmlFor="req-memo">
          <textarea id="req-memo" style={textarea} rows={2} value={f.memo} placeholder={t('simpleMemoHint')}
            onChange={function (e) { set('memo', e.target.value); }} />
        </Field>
        <div style={{ marginTop: 6 }}><NoteBox><div>{t('simpleMemoLangNote')}</div></NoteBox></div>
      </div>
    </div>
  </SimpleCard>);
}

function DesktopForm(props) {
  var t = props.t;
  var f = props.form;
  var mode = props.mode;
  var photoDirect = mode === 'photo' && props.choice === 'direct';
  var vehicleOpen = mode === 'manual' || (mode === 'photo' && props.choice === 'ai');
  var locationOpen = mode !== 'none' && !photoDirect;
  var doneMethod = mode !== 'none' ? 1 : 0;
  var doneVehicle = doneMethod && (vehicleOpen ? (f.car_model.trim() ? 1 : 0) : 1);
  var doneLocation = doneMethod && (locationOpen
    ? ((f.location.trim() || props.photos.length || f.listing_url.trim()) ? 1 : 0) : 1);

  return (<div style={col}>
    <div style={headRow}>
      <button type="button" style={backBtn} aria-label={t('actionBack')} data-testid="req-back" onClick={props.onBack}>‹</button>
      <h2 style={titleSt}>{t('simpleB1CtaTitleAction')}</h2>
      <Progress t={t} done={doneMethod + doneVehicle + doneLocation} />
    </div>

    <StepMethod t={t} desktop active={mode} onPhoto={props.onPhoto} onLink={props.onLink} onManual={props.onManual} />

    {mode === 'photo' ? (<PhotoCard t={t} photos={props.photos} choice={props.choice} ocr={props.ocr}
      error={props.errors.photo} onAdd={props.onAdd} onDropFiles={props.onDropFiles} onRemove={props.onRemove}
      onChoice={props.onChoice} onRunOcr={props.onRunOcr} onManualEntry={props.onManualEntry} onRetry={props.onRunOcr} />) : null}

    {mode === 'link' ? (<SimpleCard title={t('simpleB3LinkTitle')}>
      <div style={body}>
        <Field label={t('evalFormListingUrl')} htmlFor="req-url" error={props.errors.url}>
          <input id="req-url" type="url" dir="ltr" style={input} value={f.listing_url} placeholder="https://"
            onChange={function (e) { props.onChange('listing_url', e.target.value); }} />
        </Field>
        {props.clipboardHost ? (<div>
          <button type="button" style={pill} data-testid="clip-pill" onClick={props.onPasteClipboard}>
            {t('simpleB3LinkPaste', { host: props.clipboardHost })}
          </button>
        </div>) : null}
        <NoteBox><div>{t('simpleB3LinkNote')}</div></NoteBox>
      </div>
    </SimpleCard>) : null}

    {vehicleOpen ? (<VehicleCard t={t} form={f} onChange={props.onChange} modelError={props.errors.model}
      ocrFilled={props.ocr === 'filled'} photoCount={props.photos.length} />) : null}

    {mode === 'none' ? null : (<LocationCard t={t} form={f} onChange={props.onChange} open={locationOpen}
      showRefLink={mode !== 'link'} locationError={props.errors.location} urlError={props.errors.url}
      onPickMap={props.onPickMap} onPickAddr={props.onPickAddr} />)}

    {props.children}
  </div>);
}

export default DesktopForm;
